/**
 * MiaFlowAuth Compatibility Wrapper
 * Provides backward compatibility for code that still references miaFlowAuth
 * for tenant/project selection. Authentication is now handled by authtool-client-js.
 * 
 * @deprecated Use tenantManager directly for tenant/project selection
 */
import tenantManager from '../utils/tenantManager';

class MiaFlowAuthCompat {
  constructor() {
    console.warn('MiaFlowAuth is deprecated for authentication. Use authtool-client-js and useAuth hook instead. Only tenant/project selection methods are supported.');
  }

  /**
   * Get selected tenant (delegates to tenantManager)
   */
  getSelectedTenant() {
    return tenantManager.getSelectedTenant();
  }

  /**
   * Set selected tenant (delegates to tenantManager)
   */
  setSelectedTenant(tenant) {
    tenantManager.setSelectedTenant(tenant);
  }

  /**
   * Get selected project (delegates to tenantManager)
   */
  getSelectedProject() {
    return tenantManager.getSelectedProject();
  }

  /**
   * Set selected project (delegates to tenantManager)
   */
  setSelectedProject(project) {
    tenantManager.setSelectedProject(project);
  }

  /**
   * @deprecated Authentication methods removed - use authtool-client-js
   */
  async startAuthFlow() {
    throw new Error('startAuthFlow is deprecated. Use the login method from useAuth() hook or redirect to authtool login endpoint.');
  }

  /**
   * @deprecated Authentication methods removed - use authtool-client-js
   */
  async isAuthenticated() {
    throw new Error('isAuthenticated is deprecated. Use isAuthenticated from useAuth() hook.');
  }

  /**
   * @deprecated Authentication methods removed - use authtool-client-js
   */
  async getUserInfo() {
    throw new Error('getUserInfo is deprecated. Use user from useAuth() hook.');
  }

  /**
   * @deprecated Authentication methods removed - use authtool-client-js
   */
  getStoredUserInfo() {
    throw new Error('getStoredUserInfo is deprecated. Use user from useAuth() hook.');
  }

  /**
   * @deprecated Authentication methods removed - use authtool-client-js
   */
  async logout() {
    throw new Error('logout is deprecated. Use the logout method from useAuth() hook.');
  }
}

// Export singleton instance for backward compatibility
const miaFlowAuth = new MiaFlowAuthCompat();
export default miaFlowAuth;
